import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  class: "returnTripPassengerForm"
};
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "回城车", -1);
const _hoisted_3 = {
  class: "content"
};
const _hoisted_4 = {
  class: "banner"
};
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", {
  class: "h1"
}, "发布回城车需求", -1);
const _hoisted_6 = {
  class: "description"
};
const _hoisted_7 = {
  class: "card passenger-form"
};
const _hoisted_8 = {
  class: "passenger-input passenger-mobile"
};
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", {
  class: "separate"
}, null, -1);
const _hoisted_10 = {
  class: "passenger-input passenger-name"
};
const _hoisted_11 = {
  key: 0,
  class: "passenger-input passenger-name"
};
const _hoisted_12 = {
  class: "card passenger-contact-passenger",
  style: {
    "border-radius": "12px 12px 0 0"
  }
};
const _hoisted_13 = {
  class: "card passenger-contact-passenger",
  style: {
    "margin-top": "-24px",
    "border-radius": "0 0 12px 12px"
  }
};
const _hoisted_14 = {
  key: 0,
  class: "price"
};
const _hoisted_15 = {
  key: 1,
  class: "price"
};
const _hoisted_16 = {
  class: "hint"
};
const _hoisted_17 = /*#__PURE__*/_createElementVNode("ul", {
  class: "info"
}, [/*#__PURE__*/_createElementVNode("li", null, "回城车需求发布后可能需要等待司机应答；"), /*#__PURE__*/_createElementVNode("li", null, "订单匹配成功后，请及时与司机沟通协商。")], -1);
const _hoisted_18 = {
  class: "button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_radio = _resolveComponent("van-radio");
  const _component_van_radio_group = _resolveComponent("van-radio-group");
  const _component_van_button = _resolveComponent("van-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, [_createElementVNode("div", null, [_createVNode(_component_van_icon, {
    name: "success"
  }), _createTextVNode(" 同路司机，一往同城 ")]), _createElementVNode("div", null, [_createVNode(_component_van_icon, {
    name: "success"
  }), _createTextVNode(" 经济实惠，顺风顺水 ")])])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createVNode(_component_van_icon, {
    name: "flag-o"
  }), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.nowEndAddress = $event),
    placeholder: "您要去哪里？",
    onClick: _cache[1] || (_cache[1] = $event => $options.goSelectAddress('end', this.nowEndPosition))
  }, null, 512), [[_vModelText, $data.nowEndAddress]])]), _hoisted_9, _createElementVNode("div", _hoisted_10, [_createVNode(_component_van_icon, {
    name: "location-o"
  }), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.nowStartAddress = $event),
    placeholder: "在哪出发（默认当前位置）",
    onClick: _cache[3] || (_cache[3] = $event => $options.goSelectAddress('start', this.nowStartPosition))
  }, null, 512), [[_vModelText, $data.nowStartAddress]])]), false ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_van_icon, {
    name: "underway-o",
    size: "14px"
  }), _withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.departure_time = $event),
    placeholder: "何时出发（默认尽快出发）",
    onClick: _cache[5] || (_cache[5] = (...args) => $props.showDepartureTimeDatePickerClick && $props.showDepartureTimeDatePickerClick(...args))
  }, null, 512), [[_vModelText, $data.departure_time]])])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_12, [_createTextVNode(" 乘车人数： "), _createVNode(_component_van_radio_group, {
    modelValue: $data.seats_count,
    "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.seats_count = $event),
    direction: "horizontal"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_radio, {
      name: 1,
      "checked-color": "#ff9500",
      onClick: _cache[6] || (_cache[6] = $event => $options.clickSeatsCount(1))
    }, {
      default: _withCtx(() => [_createTextVNode("1位")]),
      _: 1
    }), _createVNode(_component_van_radio, {
      name: 2,
      "checked-color": "#ff9500",
      onClick: _cache[7] || (_cache[7] = $event => $options.clickSeatsCount(2))
    }, {
      default: _withCtx(() => [_createTextVNode("2位")]),
      _: 1
    }), _createVNode(_component_van_radio, {
      name: 3,
      "checked-color": "#ff9500",
      onClick: _cache[8] || (_cache[8] = $event => $options.clickSeatsCount(3))
    }, {
      default: _withCtx(() => [_createTextVNode("3位")]),
      _: 1
    })]),
    _: 1
  }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_13, [_createTextVNode(" 预估价格： "), $data.estimated_cost ? (_openBlock(), _createElementBlock("strong", _hoisted_14, "￥" + _toDisplayString($data.estimated_cost), 1)) : (_openBlock(), _createElementBlock("strong", _hoisted_15, "￥0.00"))]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_van_icon, {
    name: "warning",
    color: "#1989fa"
  }), _hoisted_17]), _createElementVNode("div", _hoisted_18, [_createVNode(_component_van_button, {
    color: "#ff8c00",
    block: "",
    plain: "",
    disabled: !($data.nowEndAddress && $data.nowEndAddress.length > 0),
    onClick: _cache[10] || (_cache[10] = $event => $options.submitOrder(true))
  }, {
    default: _withCtx(() => [_createTextVNode(" 只进行需求匹配 ")]),
    _: 1
  }, 8, ["disabled"]), _createVNode(_component_van_button, {
    color: "#ff9500",
    block: "",
    disabled: !($data.nowEndAddress && $data.nowEndAddress.length > 0),
    onClick: _cache[11] || (_cache[11] = $event => $options.submitOrder(false))
  }, {
    default: _withCtx(() => [_createTextVNode(" 发布并匹配需求 ")]),
    _: 1
  }, 8, ["disabled"])])])]);
}